import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import ReactMarkdown from "react-markdown";
import "./RagBot.css";

const RagBot = () => {
  const storedJwt = localStorage.getItem("token");
  const [jwt] = useState(storedJwt || null);
  const [inputText, setInputText] = useState("");
  const [chatLog, setChatLog] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const chatEndRef = useRef(null);
  const ragApiUrl = "https://utility.cscoreentities.devtest.gf.aws.scania.com/loadrunner/jwt/api/v1/ask";
  
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [chatLog]);

  const handleSend = async () => {
    if (!inputText.trim()) return;

    const userQuestion = inputText.trim();
    setChatLog((prev) => [...prev, { role: "user", text: userQuestion }]);
    setInputText("");
    setIsLoading(true);

    try {
      const options = {
        headers: {
          "Content-Type": "application/json",
          "X-Client": "ce/pulse-web-console",
          "Access-Control-Allow-Origin": "*",
          Authorization: jwt,
        },
      };
      const response = await axios.post(ragApiUrl
        , {
        question: userQuestion,
      }, options);

      const { answer, context_chunks_used } = response.data;
      const systemResponse = `**🧠 Answer:**\n${answer}\n\n_Context chunks used: ${context_chunks_used}_`;

      setChatLog((prev) => [...prev, { role: "system", text: systemResponse }]);
    } catch (error) {
      setChatLog((prev) => [
        ...prev,
        { role: "system", text: "Failed to get response from backend api. Check if api is running." },
      ]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") handleSend();
  };

  const toggleDarkMode = () => setDarkMode(!darkMode);

  return (
    <div className={`chat-container ${darkMode ? "dark" : "light"}`}>
      <div className="chat-header">
        <h2>🔍 Ask a Question to Core-Entities Bot</h2>
        <button className="toggle-mode" onClick={toggleDarkMode}>
          {darkMode ? "🌞 Light Mode" : "🌙 Dark Mode"}
        </button>
      </div>

      <div className="chat-layout">
        <aside className="chat-sidebar">
          <h4>🗃️ History</h4>
          <ul>
            {chatLog
              .filter((msg) => msg.role === "user")
              .map((msg, idx) => (
                <li key={idx}>{msg.text.slice(0, 40)}...</li>
              ))}
          </ul>
        </aside>

        <main className="chat-box">
          {chatLog.map((msg, idx) => (
            <div key={idx} className={`chat-message ${msg.role}`}>
              <ReactMarkdown
                components={{
                  pre({ node, ...props }) {
                    return <pre {...props} />;
                  },
                  code({ node, inline, className, children, ...props }) {
                    return (
                      <code className={className} {...props}>
                        {children}
                      </code>
                    );
                  },
                }}
              >
                {msg.text}
              </ReactMarkdown>
            </div>
          ))}
          {isLoading && (
            <div className="chat-message system typing">
              <em>Bot is thinking...</em>
            </div>
          )}
          <div ref={chatEndRef} />
        </main>
      </div>

      <div className="chat-input">
        <input
          type="text"
          placeholder="Type your question here..."
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <button onClick={handleSend} disabled={isLoading}>
          {isLoading ? "Thinking..." : "Send"}
        </button>
      </div>
    </div>
  );
};

export default RagBot;
